<script>
  export default {
    name: 'AccountLiab',
    props: {
      propAccountsData: {
        type: Array
      },
      propInsuredAge: {
        type: Number,
        default: 0
      }
    },
    data() {
      let result = {
        add: [],
        take: []
      }

      this.propAccountsData.forEach(item => {
        let addAndTake = item.accountData.addAndTakeData

        if (addAndTake && Array.isArray(addAndTake)) {

          addAndTake.forEach(at => {
            if (Array.isArray(at.adjustData) && at.adjustData.length > 0) {
              if (Array.isArray(result[at.key])) {
                result[at.key].push(at.adjustData)
              }
            }
          })
        }
      })

      return {
        accountList: result
      }
    },
    computed: {

    },
    watch: {

    },
    created() {

    },
    mounted() {

    },
    methods: {
      _transformText(type, ary) {
        let start = ary[0]
        let end = ary[1]
        let money = ary[2]
        let age = this.propInsuredAge + start
        let hand = type === 'add' ? '交' : '领'
        if (start === end) {
          return `${age}岁${hand}<span>${money}</span>元`
        } else if (start < end) {
          let eage = this.propInsuredAge + end
          return `${age}岁—${eage}岁每年${hand}<span>${money}</span>元`
        }
      }
    }
  }
</script>

<template>
  <div
    v-if="accountList.add.length || accountList.take.length"
    class="account-wrap"
  >
    <div class="hd after-bd-b">
      追加领取
    </div>
    <div class="bd">
      <div
        v-for="(adds, index) in accountList.add"
        v-if="accountList.add.length"
        class="account-item"
        :class="{'after-bd-b': index !== accountList.add.length - 1}"
      >
        <div v-if="index === 0" class="description1 title">
          灵活追加，复利计息稳健增值
        </div>
        <div
          v-for="item in adds"
          class="description1"
          v-html="_transformText('add', item)"
        />
      </div>
      <div
        v-for="(takes, index) in accountList.take"
        v-if="accountList.take.length"
        class="account-item"
        :class="{'after-bd-b': index !== accountList.take.length - 1}"
      >
        <div v-if="index === 0" class="description1 title">
          灵活领取，满足人生各阶段保障需求
        </div>
        <div
          v-for="item in takes"
          class="description1"
          v-html="_transformText('take', item)"
        />
      </div>
    </div>
  </div>
</template>

<style scoped>
  @import 'variable';

  .account-wrap {
    @apply --widthcenter;
    background-color: var(--white-color);
    margin-bottom: 10px;
    padding: 15px 0;
    border-radius: 4px;
    .hd {
      position: relative;
      margin-bottom: 12px;
      padding-bottom: 15px;
      font-size: 17px;
      font-weight: bold;
      text-align: center;
      &:after {
        width: 94.366%;
        left: 2.816%;
      }
    }
    .bd {
      padding: 0 20px 0 30px;
    }
    .account-item {
      padding: 5px 0;
      &:first-child {
        padding-top: 0;
      }
      &:last-child {
        padding-bottom: 0;
      }
      .description1 {
        &:before {
          content: none;
        }
      }
      .title {
        &:before {
          content: '';
        }
      }
      .description2 {
        font-size: 15px;
        margin-bottom: 5px;
        color: var(--thre-color);
      }
      >div {
        &:last-child {
          margin-bottom: 0;
        }
        &:first-child {
          margin-top: 0;
        }
      }
    }
  }
</style>